/** @jsx jsx */
import { jsx } from '@emotion/react'
import React from 'react'

import IconChevron from '../svg/IconChevron'
import AboutUsCTAButtons from './AboutUsCTAButtons'
import H1 from '../typography/H1'
import P from '../typography/P'
import { mq } from '../../theme'

interface Props {
  img: string
}

const AboutUsSection1: React.FC<Props> = (props) => {
  const { img } = props

  return (
    <React.Fragment>
      <div
        css={[
          {
            background: `url(${img})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
            position: 'absolute',
            top: 0,
            bottom: 0,
            left: 0,
            right: 0,
          },
        ]}
      >
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            width: '100%',
            textAlign: 'center',
          }}
        >
          <H1 lead={true} css={[mq('mt0'), mq('mb0')]}>
            An industry solution for
            <br /> sourcing Art & Design
          </H1>
          <P css={{ color: 'white' }}>
            <b>
              Specify pieces for your projects and
              <br css={[mq('d-none', 'xs'), mq('d-inline', 'sm')]} /> spaces,
              seamlessly.
            </b>
          </P>
          <div css={[mq('mt1')]}>
            <AboutUsCTAButtons />
          </div>
        </div>
        <div css={{ position: 'absolute', bottom: '3em', width: '100%' }}>
          <div css={{ display: 'flex', justifyContent: 'center' }}>
            <div
              id="scrollDown"
              css={{
                backgroundColor: 'white',
                width: '28px',
                height: '28px',
                borderRadius: '100%',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <a href="#scrollDown" css={{ lineHeight: '0px' }}>
                <IconChevron size={10} variant="primary" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  )
}

export default AboutUsSection1
